/** Model catalogue shown on the site. Each family is one "line" on the route map. */

export type ApiFormat = 'openai' | 'anthropic' | 'gemini';

export const FORMAT_NAMES: Record<ApiFormat, string> = {
  openai: 'OpenAI',
  anthropic: 'Anthropic',
  gemini: 'Gemini',
};

export interface ModelFamily {
  id: 'claude' | 'gpt' | 'gemini' | 'grok';
  name: string;
  /** CSS custom property with the family's line colour. */
  color: string;
  formats: readonly ApiFormat[];
  /** Newest first. */
  models: readonly string[];
  /** Shown with prices on the landing page. */
  featured: readonly string[];
}

export const MODEL_FAMILIES: readonly ModelFamily[] = [
  {
    id: 'claude',
    name: 'Claude',
    color: 'var(--line-claude)',
    formats: ['anthropic', 'openai'],
    featured: ['claude-opus-5-5', 'claude-sonnet-5-5', 'claude-haiku-4-5-20251001'],
    models: [
      'claude-fable-5-1',
      'claude-fable-5',
      'claude-opus-5-5',
      'claude-opus-5',
      'claude-sonnet-5-5',
      'claude-sonnet-5',
      'claude-opus-4-8',
      'claude-opus-4-7',
      'claude-opus-4-6',
      'claude-sonnet-4-6',
      'claude-haiku-4-5-20251001',
    ],
  },
  {
    id: 'gpt',
    name: 'GPT',
    color: 'var(--line-gpt)',
    formats: ['openai'],
    featured: ['gpt-6.1-sol', 'gpt-6-astra', 'gpt-5.6-terra'],
    models: ['gpt-6.1-sol', 'gpt-6-sol', 'gpt-6-astra', 'gpt-5.6-sol', 'gpt-5.6-terra', 'gpt-5.5'],
  },
  {
    id: 'gemini',
    name: 'Gemini',
    color: 'var(--line-gemini)',
    formats: ['gemini', 'openai'],
    featured: ['gemini-3.1-pro-high', 'gemini-3.8-flash', 'gemini-3-flash'],
    models: [
      'gemini-3.8-flash',
      'gemini-3.7-flash',
      'gemini-3.6-flash',
      'gemini-3.5-flash',
      'gemini-3.1-pro-high',
      'gemini-3.1-pro-low',
      'gemini-3.1-pro-preview',
      'gemini-3-pro-high',
      'gemini-3-flash',
      'gemini-3-flash-preview',
    ],
  },
  {
    id: 'grok',
    name: 'Grok',
    color: 'var(--line-grok)',
    formats: ['openai'],
    featured: ['grok-4.7'],
    models: ['grok-4.7', 'grok-4.6', 'grok-4.5'],
  },
];

export const API_BASE = 'https://api.lowcostrouter.com';

/** Base URL to put into each SDK. */
export const BASE_URLS: Record<ApiFormat, string> = {
  openai: `${API_BASE}/v1`,
  anthropic: API_BASE,
  gemini: API_BASE,
};
